import { palette } from '@solvhealth/jigsaw-v1';
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useNextOrLastAppointment } from '~/components/AccountGetsMarried/hooks/useNextOrLastAppointment';
import { colors } from '../../../../../../constants/colors';
import useSelectUserProfile from '~/components/AccountGetsMarried/hooks/useSelectUserProfile';
import { isUserProfileCoveredByMembership } from '~/core/util/account';
import AppointmentCard, {
  useShouldHideAppointmentCard,
} from '~/components/AccountGetsMarried/components/GetCare/components/AccountHeadline/components/AppointmentCard';

const Root = styled.div.withConfig({ componentId: 'sc-1wzpu73-0' })<{ $isActiveMembership: boolean }>`
  width: 100%;
  padding: 0 24px 24px;
  position: relative;
  box-sizing: border-box;
  background: ${({ $isActiveMembership }) =>
    $isActiveMembership ? palette.teal.xlight : colors.marriedToPurple};
`;

const ContentRoot = styled.div.withConfig({ componentId: 'sc-1wzpu73-1' })`
  width: 100%;
  margin: 0 auto;
`;

type Props = {
  userProfileId: string;
};

const AccountHeadlineContent = ({ userProfileId }: { userProfileId: string }) => {
  const userProfile = useSelectUserProfile(userProfileId);
  const accountSummary = useSelector((state: any) => state.account.summary);
  const shouldShowMembershipBranding = isUserProfileCoveredByMembership(
    accountSummary,
    userProfile
  );

  const shouldHide = useShouldHideAppointmentCard(userProfileId);
  if (shouldHide) {
    return null;
  }

  return (
    <Root $isActiveMembership={shouldShowMembershipBranding}>
      <ContentRoot>
        <AppointmentCard userProfileId={userProfileId} />
      </ContentRoot>
    </Root>
  );
};

const AccountHeadline = (props: Props) => {
  const { userProfileId } = props;

  const { appointment } = useNextOrLastAppointment(userProfileId);
  if (!appointment) {
    return null;
  }

  return <AccountHeadlineContent userProfileId={userProfileId} />;
};

export default AccountHeadline;
